import { ReactNode } from 'react';
import { Box, Container, Flex, Heading, Stack, Text } from '@chakra-ui/react';

export interface AppLayoutProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
}

const AppLayout = ({ title, subtitle, actions, children }: AppLayoutProps) => {
  return (
    <Box bg="elevated" minH="100vh" py={{ base: 10, md: 14 }}>
      <Container maxW="container.xl">
        <Stack spacing={{ base: 8, md: 12 }}>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            align={{ base: 'stretch', md: 'center' }}
            justify="space-between"
            gap={{ base: 6, md: 8 }}
          >
            <Stack spacing={3} flex={1}>
              <Heading size="lg" color="text.900">
                {title}
              </Heading>
              {subtitle && (
                <Text color="text.600" fontSize="lg">
                  {subtitle}
                </Text>
              )}
            </Stack>
            {actions && (
              <Stack
                direction={{ base: 'column', sm: 'row' }}
                spacing={3}
                justify={{ base: 'stretch', md: 'flex-end' }}
                align={{ base: 'stretch', md: 'center' }}
              >
                {actions}
              </Stack>
            )}
          </Flex>
          {children}
        </Stack>
      </Container>
    </Box>
  );
};

export default AppLayout;
